import { render, staticRenderFns } from "./DateAdd.vue?vue&type=template&id=3978955c&scoped=true"
import script from "./DateAdd.vue?vue&type=script&lang=js"
export * from "./DateAdd.vue?vue&type=script&lang=js"
import style0 from "./DateAdd.vue?vue&type=style&index=0&id=3978955c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978955c",
  null
  
)

export default component.exports